import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Button, Tooltip, Typography, Toolbar, Chip} from '@material-ui/core';
import {
  Add as AddIcon,
  ViewColumn as ViewColumnIcon,
  Edit as EditIcon,
  SaveAlt as SaveAltIcon,
} from '@material-ui/icons';
import {grey} from '@material-ui/core/colors';
import {useStyles} from 'Utility/styles';
import {canWrite} from 'Sbs/service/SbsService';

function SbsLobbyActionToolbar(props) {
  const {sbss, selectedSbs, onExportList} = props;
  const classes = useStyles();
  const [canWriteSbs, setCanWriteSbs] = useState(false);

  useEffect(() => {
    const checkWritePermission = async () => {
      if (selectedSbs?.id) {
        try {
          const hasWritePermission = await canWrite(selectedSbs.id);

          setCanWriteSbs(hasWritePermission === true);
        } catch (error) {
          console.error('Error checking write permission:', error);
          setCanWriteSbs(false);
        }
      } else {
        setCanWriteSbs(false);
      }
    };

    checkWritePermission();
  }, [selectedSbs?.id]);

  return (
    <Toolbar>
      <div
        style={{
          flex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Typography variant="h6" color="inherit">
          Sbs Lobby
        </Typography>
        <Chip
          label={`Total: ${sbss.length}`}
          style={{backgroundColor: grey['300'], marginLeft: 8}}
        />
      </div>
      <div
        style={{
          flex: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Tooltip
          title={
            !selectedSbs
              ? 'Select SBS To Edit'
              : !canWriteSbs
              ? 'You do not have write permission for this SBS'
              : 'Edit SBS'
          }
        >
          <span>
            <Button
              variant="outlined"
              href={`#/Sbss/${selectedSbs?.id}/update`}
              color="primary"
              className={classes.spacedButton}
              disabled={!selectedSbs || !canWriteSbs}
              startIcon={<EditIcon />}
            >
              edit: SBS
            </Button>
          </span>
        </Tooltip>
        <Tooltip title={selectedSbs ? 'View SBS' : 'Select SBS To View'}>
          <span>
            <Button
              variant="contained"
              href={`#/Sbss/${selectedSbs?.id}`}
              color="primary"
              className={classes.spacedButton}
              disabled={!selectedSbs}
              startIcon={<ViewColumnIcon />}
            >
              view: SBS
            </Button>
          </span>
        </Tooltip>
        <Tooltip title="Create New SBS">
          <Button
            variant={!selectedSbs ? 'contained' : 'outlined'}
            href="#/Sbss/create"
            color="primary"
            className={classes.spacedButton}
            startIcon={<AddIcon />}
          >
            create: SBS
          </Button>
        </Tooltip>
        <Tooltip title="Export: List">
          <Button
            className={classes.spacedButton}
            aria-label="Export: List"
            onClick={onExportList}
            startIcon={<SaveAltIcon />}
          >
            export: List
          </Button>
        </Tooltip>
      </div>
    </Toolbar>
  );
}

SbsLobbyActionToolbar.propTypes = {
  sbss: PropTypes.arrayOf(PropTypes.shape({id: PropTypes.string.isRequired}))
    .isRequired,
  selectedSbs: PropTypes.shape({id: PropTypes.string.isRequired}),
  onExportList: PropTypes.func.isRequired,
};

SbsLobbyActionToolbar.defaultProps = {
  selectedSbs: null,
};

export default SbsLobbyActionToolbar;
